import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const DialogContentStyle = ({ theme }) => ({
  paddingTop: '40px !important',
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: '100px',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    paddingTop: '60px !important'
  }
});

export const RadioGroupStyle = () => ({
  width: '100%',
  gap: '24px'
});

const SummaryFormWrapper = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '3 / 11'
  }
});

const PrintButtonStyle = () => ({
  padding: 0,
  height: 'auto'
});

const PrintedBoxStyle = () => ({
  '@media print': {
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const Wrapper = styled(Stack)(SummaryFormWrapper);
export const PrintButton = styled(Button)(PrintButtonStyle);
export const PrintedBox = styled(Box)(PrintedBoxStyle);
